/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { useEffect, useState } from 'react';

import { ToDoItem } from 'client-code/recordings';

import { Channel } from '../../../../../core/entities';
import { TChannelV2 } from '../../../../../core/types';
import { Mousetrap } from '../../../../common';
import { Spinner } from '../../../../VideoPlayerUI/Spinner';
import { isToDoGroupHeader } from '../ToDoList.utils';
import ToDoGroupHeader from './ToDoGroupHeader/ToDoGroupHeader';
import ToDoOfferItem from './ToDoOfferItem/ToDoOfferItem';

import './ToDoListContent.scss';

export type ToDoListContentProps = {
    toDoItems: ToDoItem[];
    currentPage: number;
    allChannels: Channel[] | TChannelV2[];
};

const ToDoListContent = ({ toDoItems, currentPage, allChannels }: ToDoListContentProps) => {
    const [displaySpinner, setDisplaySpinner] = useState(false);

    useEffect(() => {
        setDisplaySpinner(toDoItems.length === 0 && currentPage !== 0);
    }, [toDoItems.length, currentPage]);

    const createToDoRender = () => {
        let rowIndex = 0;

        return toDoItems.reduce<JSX.Element[]>((acc, item) => {
            if (isToDoGroupHeader(item)) {
                acc.push(
                    <Mousetrap value={item.name} key={item.name}>
                        <ToDoGroupHeader key={item.name} header={item} />
                    </Mousetrap>,
                );
            } else {
                acc.push(
                    <ToDoOfferItem
                        key={`${item.offerId}-${rowIndex}`}
                        item={item}
                        allChannels={allChannels}
                        rowIndex={rowIndex}
                    />,
                );
                rowIndex += 1;
            }
            return acc;
        }, []);
    };

    return (
        <div className="to-do-list-content">
            {displaySpinner ? (
                <div className="to-do-list-spinner">
                    <Spinner message="" />
                </div>
            ) : (
                createToDoRender()
            )}
        </div>
    );
};

export default ToDoListContent;
